export enum FileUploadErrorCode {
  ContentTypeNotFound = 'content_type_not_found',
  FileSizeTooLarge = 'file_size_too_large',
  FileConfigurationNotFound = 'file_configuration_not_found',
  AwsError = 'aws_error',
  InternalServerError = 'internal_server_error',
  UnknownError = 'unknown_error',
  ParseError = 'parse_error',
  FailedToUpload = 'failed_to_upload',
  SuccessfullyUploaded = 'successfully_uploaded',
  MaximumAllowedSize = 'maximum_allowed_size'
}

export enum FileUploadTranslationsCode {
  ContentTypeNotFound = 'FileUploadContentTypeNotFound',
  FileSizeTooLarge = 'FileUploadFileSizeTooLarge',
  FileConfigurationNotFound = 'FileUploadFileConfigurationNotFound',
  AwsError = 'FileUploadAwsError',
  InternalServerError = 'FileUploadInternalServerError',
  UnknownError = 'FileUploadUnknownError',
  ParseError = 'FileUploadParseError',
  FailedToUpload = 'FileUploadFailedToUpload',
  SuccessfullyUploaded = 'FileUploadSuccessfullyUploaded',
  MaximumAllowedSize = 'FileUploadMaximumAllowedSize'
}

export const FileUploadErrorConfig = {
    [FileUploadErrorCode.ContentTypeNotFound]: {
        translationCode: FileUploadTranslationsCode.ContentTypeNotFound,
        defaultMessage: 'Content type not found or unsupported'
    },
    [FileUploadErrorCode.FileSizeTooLarge]: {
        translationCode: FileUploadTranslationsCode.FileSizeTooLarge,
        defaultMessage: 'File size exceeds maximum allowed limit'
    },
    [FileUploadErrorCode.FileConfigurationNotFound]: {
        translationCode: FileUploadTranslationsCode.FileConfigurationNotFound,
        defaultMessage: 'File configuration not found'
    },
    [FileUploadErrorCode.AwsError]: {
        translationCode: FileUploadTranslationsCode.AwsError,
        defaultMessage: 'AWS service error occurred'
    },
    [FileUploadErrorCode.InternalServerError]: {
        translationCode: FileUploadTranslationsCode.InternalServerError,
        defaultMessage: 'Internal server error occurred'
    },
    [FileUploadErrorCode.UnknownError]: {
        translationCode: FileUploadTranslationsCode.UnknownError,
        defaultMessage: 'An unknown error occurred'
    },
    [FileUploadErrorCode.ParseError]: {
        translationCode: FileUploadTranslationsCode.ParseError,
        defaultMessage: 'Failed to parse file content'
    },
    [FileUploadErrorCode.FailedToUpload]: {
        translationCode: FileUploadTranslationsCode.FailedToUpload,
        defaultMessage: 'Failed to upload'
    },
    [FileUploadErrorCode.SuccessfullyUploaded]: {
        translationCode: FileUploadTranslationsCode.SuccessfullyUploaded,
        defaultMessage: 'Successfully uploaded'
    },
    [FileUploadErrorCode.MaximumAllowedSize]: {
        translationCode: FileUploadTranslationsCode.MaximumAllowedSize,
        defaultMessage: 'Maximum allowed size is'
    }
} as const;

// Type helper to get the configuration for a specific error code
export type FileUploadErrorConfigType = typeof FileUploadErrorConfig;
